import React from 'react';

const ArrangeResults = ({ 
  results = [], 
  correctOrder = [], 
  statistic = '', 
  scores = [],
  cricketers = [],
  currentPlayerId = '',
  currentRound = 1,
  totalRounds = 5,
  isGameFinished = false,
  onPlayAgain,
  onExitToHome
}) => {
  
  const getCricketerById = (id) => {
    return cricketers.find(c => c.id === id) || { name: 'Unknown', stats: {} };
  };

  const getPositionColor = (actualPosition, correctPosition) => {
    const diff = Math.abs(actualPosition - correctPosition);
    if (diff === 0) return '#059669'; // Perfect - Green
    if (diff === 1) return '#0891b2'; // Close - Blue
    if (diff === 2) return '#ea580c'; // Far - Orange
    return '#dc2626'; // Very far - Red
  };

  const sortedResults = [...results].sort((a, b) => b.score - a.score);
  const roundWinner = sortedResults[0];
  
  // For final results, use cumulative scores
  const sortedScores = [...scores].sort((a, b) => b.score - a.score);
  const gameWinner = sortedScores[0];

  return (
    <div className="screen active">
      <div className="card results-card">
        <h2>🏆 {isGameFinished ? 'Final Results' : 'Round Results'}</h2>
        <div className="round-info">
          <span className="round-badge">Round {currentRound} of {totalRounds}</span>
        </div>
        
        {isGameFinished && (
          <div className="winner-announcement">
            <div className="trophy-icon">🥇</div>
            <h3>Game Winner: {gameWinner?.id}</h3>
            <p className="winner-score">Final Score: {gameWinner?.score} points</p>
          </div>
        )}
        
        {!isGameFinished && (
          <div className="round-summary">
            <h3>Round {currentRound} Complete!</h3>
            <p>Best arrangement: {roundWinner?.playerId} ({roundWinner?.score} points this round)</p>
            <p>Next round starting soon...</p>
          </div>
        )}

        <div className="results-section">
          <h4>Correct Order ({statistic}):</h4>
          <div className="correct-order">
            {correctOrder.map((cricketerId, position) => {
              const cricketer = getCricketerById(cricketerId);
              const statValue = cricketer.stats[statistic] || cricketer.chosen_stat_value || 0;
              
              return (
                <div key={cricketerId} className="correct-order-item">
                  <span className="position-badge correct">{position + 1}</span>
                  <div className="cricketer-details">
                    <strong>{cricketer.name}</strong>
                    <div className="stat-value">{statistic}: {statValue}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="results-section">
          <h4>Your Results:</h4>
          {results.filter(result => result.playerId === currentPlayerId).map((result, index) => (
            <div key={result.playerId} className="player-result">
              <div className="player-header">
                <span className="result-position">#{index + 1}</span>
                <span className="player-name">{result.playerId}</span>
                <span className="player-score">{result.score} pts</span>
              </div>
              
              <div className="arrangement-comparison">
                <div className="arrangement-row">
                  <span className="arrangement-label">Their order:</span>
                  <div className="arrangement-items">
                    {result.arrangement.map((cricketerId, position) => {
                      const cricketer = getCricketerById(cricketerId);
                      const correctPosition = correctOrder.indexOf(cricketerId);
                      const color = getPositionColor(position, correctPosition);
                      
                      return (
                        <div 
                          key={cricketerId} 
                          className="arrangement-item"
                          style={{ borderColor: color }}
                        >
                          <span className="position-badge" style={{ backgroundColor: color }}>
                            {position + 1}
                          </span>
                          <span className="cricketer-name-short">
                            {cricketer.name.split(' (')[0]}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="results-section">
          <h4>Final Scores:</h4>
          <div className="final-scores">
            {scores.map((playerScore, index) => (
              <div key={playerScore.id} className="score-item">
                <span className="score-position">#{index + 1}</span>
                <span className="score-name">{playerScore.id}</span>
                <span className="score-points">{playerScore.score} points</span>
              </div>
            ))}
          </div>
        </div>

        <div className="results-legend">
          <h5>Color Legend:</h5>
          <div className="legend-items">
            <div className="legend-item">
              <div className="legend-color" style={{ backgroundColor: '#059669' }}></div>
              <span>Perfect position</span>
            </div>
            <div className="legend-item">
              <div className="legend-color" style={{ backgroundColor: '#0891b2' }}></div>
              <span>1 position off</span>
            </div>
            <div className="legend-item">
              <div className="legend-color" style={{ backgroundColor: '#ea580c' }}></div>
              <span>2 positions off</span>
            </div>
            <div className="legend-item">
              <div className="legend-color" style={{ backgroundColor: '#dc2626' }}></div>
              <span>3+ positions off</span>
            </div>
          </div>
        </div>

        {isGameFinished && (
          <div style={{ display: 'flex', gap: 10 }}>
            <button className="primary-btn" style={{ flex: 1, width: 'auto' }} onClick={onPlayAgain}>
              🔁 Play Again
            </button>
            <button className="secondary-btn" style={{ flex: 1, width: 'auto' }} onClick={onExitToHome}>
              🏠 Exit to Home
            </button>
          </div>
        )}
        
        {!isGameFinished && (
          <div className="next-round-info">
            <p>⏳ Waiting for next round to start...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ArrangeResults;